import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ContactFilterAttributeType, ContactFilterOperator } from "../shared/types";
import { ContactFilterOperatorSelect } from "./ContactFilterOperatorSelect";
import { IFilterEntryDescription } from "./types";

interface Props {
	name: string;
	type: ContactFilterAttributeType;
	description: IFilterEntryDescription;
}

const OperatorAndValue = styled.div`
	display: grid;
	grid-template-columns: 1fr 2fr;
	gap: ${({ theme }) => theme.spacing(2)};
`;

export const ContactFilterOperatorAndValue: FC<Props> = ({ type, description, name }) => {
	const { t } = useTranslation();
	const [{ value: operator }] = useField<ContactFilterOperator | null>(`${name}.operator`);

	return (
		<OperatorAndValue>
			<ContactFilterOperatorSelect type={type} name={name} operators={description.operators} />
			{operator &&
				operator !== "IS_EMPTY" &&
				operator !== "IS_NOT_EMPTY" &&
				description.render?.({ name: `${name}.value`, label: t("Value") }, operator)}
		</OperatorAndValue>
	);
};
